import { getConfiguration } from '@chr/common-web-ui-configuration';
import { getAxiosInstance } from '@chr/online-shared-microsite-core';
import { AppConfig } from 'react-app-env';
import { RecentOrder } from '../constants/online.homepagegateway.api';

export const userRecentOrders = async (): Promise<RecentOrder[]> =>{
  const axiosInstance = await getAxiosInstance();
  const config = await getConfiguration<AppConfig>();
  const serviceUrl = config.gatewayApiUri;

  const response = await axiosInstance.get<RecentOrder[]>(`${serviceUrl}/recent-order`);
  return response.data;
}